<template lang="pug">
  section.sidebar
    //- Mobile Sidebar Collapse
    a.is-hidden-desktop.has-text-centered.trigger-menu(@click="isHiddenMobile = !isHiddenMobile")
      p.has-text-primary(v-if="isHiddenMobile")
        small Abrir Menu #[br]
        b-icon(icon="keyboard_arrow_down" type="is-primary" size="large")
      p.has-text-primary(v-if="!isHiddenMobile")
        small Fechar Menu #[br]
        b-icon(icon="keyboard_arrow_up" type="is-primary" size="large")

    transition(name="fade")
      aside.menu(v-bind:class="{'is-hidden-mobile': isHiddenMobile}")
        p.menu-label Geral
        ul.menu-list
          li
            router-link(:to="{name: 'Dashboard'}" v-on:click.native="isHiddenMobile = true" exact) Dashboard
        section.menu-section(v-for="section in sections" v-bind:key="section.meta.label" v-if="checkMainVisibility(section)")
          p.menu-label {{section.meta.label}}
          ul.menu-list
            .section-menu-item(v-for="route in section.children" v-bind:key="route.name" v-if="checkVisibility(route)")
              li(v-if="!route.children")
                router-link(:to="{name: route.name}" v-on:click.native="isHiddenMobile = true") {{route.meta.label}}
              li(v-if="route.children && route.children.length")
                a(@click="toggleChildrenVisibility(route)")
                  | {{route.meta.label}}
                  b-icon.is-pulled-right(icon="keyboard_arrow_down" v-if="childrenOpen != route")
                  b-icon.is-pulled-right(icon="keyboard_arrow_up" v-if="childrenOpen == route")
                ul(v-if="childrenOpen == route")
                  li.section-menu-item(v-for="child in route.children" v-bind:key="child.name" v-if="checkVisibility(child)")
                    router-link(:to="{name: child.name}" v-on:click.native="isHiddenMobile = true" exact) {{child.meta.label}}
</template>

<script>
  import AuthService from '@/services/auth.js'

  export default {
    name: 'sidebar',
    data () {
      return {
        childrenOpen: {},
        isHiddenMobile: true,
        isHiddenDesktop: false
      }
    },
    computed: {
      sections () {
        return (this.$router.options.routes[1].children)
      }
    },
    methods: {
      checkMainVisibility (section) {
        if (!section || section.meta.hidden) return false
        return section.children.filter(c => this.checkVisibility(c)).length
      },
      checkVisibility (route) {
        if (route.meta.hidden) return false
        if (!route.meta.requiredPermission) return true
        return AuthService.checkPermissionSync(route.meta.requiredPermission.resource, route.meta.requiredPermission.value)
      },
      toggleChildrenVisibility (route) {
        this.childrenOpen = (this.childrenOpen === route) ? '' : route
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "~@/assets/sass/common.sass"
  .sidebar
    // background: $main-bg
    .menu-section
      padding-top: 1rem
    .trigger-menu
      position: absolute
      top: 10%
      left: 0
      width: 100%
      z-index: 1
    aside.menu
      padding-top: 5rem
      +desktop
        padding-top: 0
      .menu-label
        color: #1e7fc0
</style>



// WEBPACK FOOTER //
// Sidebar.vue?63b97eb0